import { render, staticRenderFns } from "./Barra.vue?vue&type=template&id=8077525e&scoped=true&"
import script from "./Barra.vue?vue&type=script&lang=js&"
export * from "./Barra.vue?vue&type=script&lang=js&"
import style0 from "./Barra.vue?vue&type=style&index=0&id=8077525e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8077525e",
  null
  
)

export default component.exports